import React from 'react';
import { motion } from 'framer-motion';
import { Zap } from 'lucide-react';
export function CTAButton() {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.5,
    delay: 0.6
  }} className="flex justify-center mt-12 mb-8" data-id="element-113">
      <button className="relative group" data-id="element-114">
        {/* Animated background glow */}
        <div className="absolute -inset-1 bg-gradient-to-r from-salmon via-white to-salmon rounded-full blur opacity-40 group-hover:opacity-75 transition duration-1000 group-hover:duration-200 animate-pulse" data-id="element-115"></div>

        {/* Button content */}
        <div className="relative flex items-center gap-3 px-8 py-4 bg-black border border-salmon/50 rounded-full leading-none" data-id="element-116">
          <Zap className="w-5 h-5 text-salmon group-hover:text-white transition-colors" data-id="element-117" />
          <span className="text-base font-black tracking-widest text-white uppercase" data-id="element-118">
            Escalar Mis Campañas
          </span>
        </div>
      </button>
    </motion.div>;
}